<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="dialog-title">{{ title }}</h1>
  </div>
  <div class="dialog-message">
    <p [innerHTML]="message"></p>
  </div>

  <div class="mat-dialog-actions">
    <app-primary-button (handleClick)="onDismiss()">{{ okLabel }}</app-primary-button>
  </div>
</div>
